// dependencies
import { format } from "date-fns";
import React from "react";

// components
import FilterChips from "../../../components/FilterChips";
import { Filter } from "../../../components/FilterChips/FilterChips";
// config
import { CompanyFeedbackFilter, RESPONSE_TO_REQUEST_OPTIONS, SHARED_WITH_OPTIONS } from "./CompanyFeedbackFilters";

const convertFiltersToReadableList = (filters: Partial<CompanyFeedbackFilter>) => {
	const readableList: Filter[] = [];

	Object.keys(filters).forEach((filterKey) => {
		const filter = filters[filterKey];

		if (filterKey === "author" && filter) {
			readableList.push({
				id: "author",
				type: "single-employee",
				label: "Author",
				value: { name: filter.name, id: filter.id },
			} as Filter);
		}
		if (filterKey === "subject" && filter) {
			readableList.push({
				id: "subject",
				type: "single-employee",
				label: "Subject",
				value: { name: filter.name, id: filter.id },
			} as Filter);
		}

		if (filterKey === "sharedWith" && filter) {
			const option = SHARED_WITH_OPTIONS.find((option) => option.value === filter);
			readableList.push({
				id: "sharedWith",
				type: "string",
				label: "Shared With",
				value: option?.label ?? filter,
			} as Filter);
		}

		if (filterKey === "dateBefore" && filter) {
			readableList.push({
				id: "dateBefore",
				type: "string",
				label: "Date Before",
				value: format(filter, "MMM d yyyy"),
			} as Filter);
		}

		if (filterKey === "dateAfter" && filter) {
			readableList.push({
				id: "dateAfter",
				type: "string",
				label: "Date After",
				value: format(filter, "MMM d yyyy"),
			} as Filter);
		}

		if (filterKey === "responseToRequest" && filter) {
			const option = RESPONSE_TO_REQUEST_OPTIONS.find((option) => option.value === filter);
			readableList.push({
				id: "responseToRequest",
				type: "string",
				label: "Was Requested",
				value: option?.label ?? filter,
			} as Filter);
		}

		if (filterKey === "hashTags" && Array.isArray(filter) && filter.length > 0) {
			readableList.push({
				id: "hashTags",
				type: "string",
				label: "Hashtags",
				value: filter,
			} as Filter);
		}
	});
	return readableList;
};

type ReadableCompanyFeedbackFilterChipsProps = {
	filters: Partial<CompanyFeedbackFilter>;
	setFilters: (newFilters: Partial<CompanyFeedbackFilter>) => void;
};

const ReadableCompanyFeedbackFilterChips = ({ filters, setFilters }: ReadableCompanyFeedbackFilterChipsProps) => {
	const convertedFilters = convertFiltersToReadableList(filters);

	if (convertedFilters.length === 0) {
		return null;
	}

	return (
		<div>
			<FilterChips
				filters={convertedFilters}
				label="Filters applied: "
				onDeleteFilter={(id) => {
					const currentFilters = { ...filters };
					delete currentFilters[id];
					setFilters({ ...currentFilters });
				}}
			/>
		</div>
	);
};

export default ReadableCompanyFeedbackFilterChips;
